import Boolean from "./Boolean";
import Switch from "./Switch";

const ComposerProperties = {
  Boolean,
  Switch,
};

export default ComposerProperties;